 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"68c7b4ce112d92dd0c3880030c87a88add9940cb","2":"ddcfeb08b3f64c6f5d7a65941be1b05c9d7bb1ed","3":"34c1b16385c5623e07d0bd0aa81d2ecb8cfb54a2","4":"91566937a451675d89af566f47700dc10ff4430d","5":"33ce6ab0","6":"4c355f13","7":"c05b8182","8":"component---src-pages-layout-js","9":"c24a7fba1b99f5d80b50c0c30b68044e978c8030","10":"3d900bdb8e1f0e2108d205af384a11688c946059","11":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","12":"bc62dab504a71ef8c5d240a105694d09627f06f3","13":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","15":"11e8d57d","17":"4b80be75","18":"5cf42e9e","19":"962beaf7","21":"component---src-pages-404-js","22":"component---src-pages-banner-js","23":"component---src-pages-build-better-js","24":"component---src-pages-classic-home-js","25":"component---src-pages-docs-template-js","26":"component---src-pages-integration-builder-index-tsx","27":"component---src-pages-integration-builder-sections-build-tsx","28":"component---src-pages-integration-builder-sections-card-generator-tsx","29":"component---src-pages-integration-builder-sections-code-tsx","30":"component---src-pages-integration-builder-sections-configure-tsx","31":"component---src-pages-integration-builder-sections-demo-tsx","32":"component---src-pages-integration-builder-sections-help-modal-tsx","33":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","34":"component---src-pages-integration-builder-sections-preview-tsx","35":"component---src-pages-integration-builder-sections-take-live-tsx","36":"component---src-pages-internal-js","37":"component---src-pages-signup-js","38":"component---src-pages-signupauto-js","39":"component---src-pages-support-js","40":"component---src-pages-test-card-manager-index-tsx","41":"component---src-pages-thankyou-js","42":"component---src-pages-unsubscribe-js","43":"component---src-pages-video-collection-tsx","44":"component---src-pages-video-home-tsx","45":"component---src-pages-video-watch-tsx","46":"component---src-templates-template-layout-js","47":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"74c4c9978d371684a888","2":"aa9e601f37c29e89b546","3":"16d43533e3f76538641d","4":"6029a09ffd101eea6a53","5":"9104dc4afaf9702e2d79","6":"c1a688e3a1a1c9e5b88c","7":"d17325347e2598b3cb6a","8":"494c5689dd867b77b92d","9":"da81157853f4241a3f18","10":"c5c40f3726dd7d29f079","11":"5bdfa3bf66c04b4f7d5b","12":"8eb88fd2d256e45d0b29","13":"cde4a46cc1162cf1377b","15":"28c8dc4f28792b18e5fc","17":"54f14ab2492f30326afe","18":"8e4830cb11af33ae4074","19":"62bc1c564f8681bbc110","21":"ac21dccb7344e4ab3b0d","22":"ef693b4f9d8ff7abbdc8","23":"692626dc540a58465842","24":"5bd95fe1adeea4c16d3b","25":"51976200097b4ca9b0f0","26":"4ade1c0dfc44ec153161","27":"0376520451c5da647452","28":"93ed1885377e7d3d919d","29":"47bedb2a27c1eac038fc","30":"cd285726a9e1d7080ed8","31":"0f44ee7b1058fa540d27","32":"5dce6bae83e80b8a29ab","33":"4abdf7c2fb7101bcf084","34":"52537ec176005dcf5f6f","35":"60f4269651721bdef724","36":"8837dcef6c092df393e9","37":"16567aedc887fb001532","38":"34f68345668b5db48fa1","39":"32da9d6fa1cde44a3924","40":"02c67be1aae05a5cb4ce","41":"94a76867cbdfdebbe52a","42":"5900f7386fd24104f351","43":"6b67480b05561e475bd8","44":"bf4a1ee4d032e29a62a4","45":"c22429d3b92dcb55c69d","46":"d9414db0cbf14d93e4b5","47":"0feb31c39e327491e2d3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"68c7b4ce112d92dd0c3880030c87a88add9940cb","2":"ddcfeb08b3f64c6f5d7a65941be1b05c9d7bb1ed","3":"34c1b16385c5623e07d0bd0aa81d2ecb8cfb54a2","4":"91566937a451675d89af566f47700dc10ff4430d","5":"33ce6ab0","6":"4c355f13","7":"c05b8182","8":"component---src-pages-layout-js","9":"c24a7fba1b99f5d80b50c0c30b68044e978c8030","10":"3d900bdb8e1f0e2108d205af384a11688c946059","11":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","12":"bc62dab504a71ef8c5d240a105694d09627f06f3","13":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","15":"11e8d57d","17":"4b80be75","18":"5cf42e9e","19":"962beaf7","21":"component---src-pages-404-js","22":"component---src-pages-banner-js","23":"component---src-pages-build-better-js","24":"component---src-pages-classic-home-js","25":"component---src-pages-docs-template-js","26":"component---src-pages-integration-builder-index-tsx","27":"component---src-pages-integration-builder-sections-build-tsx","28":"component---src-pages-integration-builder-sections-card-generator-tsx","29":"component---src-pages-integration-builder-sections-code-tsx","30":"component---src-pages-integration-builder-sections-configure-tsx","31":"component---src-pages-integration-builder-sections-demo-tsx","32":"component---src-pages-integration-builder-sections-help-modal-tsx","33":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","34":"component---src-pages-integration-builder-sections-preview-tsx","35":"component---src-pages-integration-builder-sections-take-live-tsx","36":"component---src-pages-internal-js","37":"component---src-pages-signup-js","38":"component---src-pages-signupauto-js","39":"component---src-pages-support-js","40":"component---src-pages-test-card-manager-index-tsx","41":"component---src-pages-thankyou-js","42":"component---src-pages-unsubscribe-js","43":"component---src-pages-video-collection-tsx","44":"component---src-pages-video-home-tsx","45":"component---src-pages-video-watch-tsx","46":"component---src-templates-template-layout-js","47":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"9ea8412a45fbe569c13f","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/migrationv1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
